(ns app.front.view.permit.download
  "Utilities for providing a download button for the permit/licence (actually verdict)"
  (:require [app.domain.verdict.model :as verdict-model]
            [core.front.carbon :as cc]
            [core.front.icons :as i]))


(defn can-download?
  "Authorities can download whenever the permit has been issued in the past (even if revoked/expired afterwards)"
  [{object-key    :verdict/file-object-key
    verdict-state :domain/state
    phase         :entity/parent}]
  (and (some? object-key)
       (or (= verdict-state :verdict.state/permit-issued)
           (and (verdict-model/post-issue-states verdict-state)
                (contains? (:granted-permissions phase) :permission.phase/authority-read)))))


(defn download-button
  "Button for downloading the verdict (i.e. permit/licence file)"
  [{:keys [tr verdict]}]
  (when (can-download? verdict)
    (cc/button
      {:kind             :tertiary
       :size             :small
       :icon             i/download
       :icon-description (tr [:verdict/download])
       :href             (str "/api/command/verdict/download?id=" (:db/id verdict))
       :data-cy          "download-permit-btn"}
      (tr [:verdict/download]))))
